// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-editor {
  line-height: normal !important;
  white-space: normal !important;
  border: none !important;
  margin: 0px !important;
  padding: 0px !important;
}

.ql-container {
  border: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/render-field/html-render.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".ql-editor {\n  line-height: normal !important;\n  white-space: normal !important;\n  border: none !important;\n  margin: 0px !important;\n  padding: 0px !important;\n}\n\n.ql-container {\n  border: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
